import { footerGroups } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="bg-background-100">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-400"></div>

      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">黑料入口</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              一个把黑料入口跳转、秒进直达链接集中起来的入口页。要的就是快，点开直接跳转开吃瓜看黑料。
            </p>
            <p className="mt-4 max-w-md text-xs leading-6 text-foreground-500">
              免责声明：本站仅为入口导航，不存储、不生产任何内容；页面所展示的条目与数据均为演示整理，内容来自公开网络，仅供学习与交流。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.id} className="md:col-span-3">
              <h3 className="text-sm text-foreground-950">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-foreground-600 transition hover:text-primary-700"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料入口 · 入口导航演示页面</p>
          <p className="flex items-center gap-2">
            <span className="flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              线路全部在线
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}